module.exports = "/images/cookie_consent_banner.svg?cbd79c1cafe7bd9afcd10e067c93770b";